"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const botones_1 = require("../../botones");
const React = require("react");
function compare(a, b) {
    return (a == b ? 0 :
        a == null ? 1 :
            b == null ? -1 :
                a > b ? 1 :
                    a < b ? -1 : 0);
}
exports.compare = compare;
/**
 * Dadas las funciones de editar y borrar devuelve un conjunto de botones de grid con los botones de editar y borrar
 * @param deps
 */
function columnaBotonesDefault(deps) {
    return [
        { iconClass: "fa fa-pencil fa-fw", style: "info", tooltip: "Editar", onClick: deps.onEdit },
        { iconClass: "fa fa-trash-o fa-fw", style: "danger", tooltip: "Eliminar", onClick: deps.onBorrar },
    ];
}
exports.columnaBotonesDefault = columnaBotonesDefault;
/**Crea una columna para el grid formada por un conjunto de botones */
function columnaBotones(botones) {
    const filtrados = botones.filter(x => x !== false).map(x => x);
    const componentes = (x) => filtrados.map((bot, i) => React.createElement(botones_1.Link, { key: i, iconClass: bot.iconClass || "fa fa-cicle fa-fw", disabled: bot.disabled && bot.disabled(x), onClick: () => bot.onClick(x), tooltip: bot.tooltip, style: bot.style }));
    return {
        title: "",
        key: "_botones",
        cell: x => ({
            data: undefined,
            view: () => React.createElement("span", { style: { whiteSpace: "nowrap" } }, componentes(x))
        })
    };
}
exports.columnaBotones = columnaBotones;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/helpers.js
// module id = 300
// module chunks = 0